import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Text, Icon } from '../../../../../components';

const DataDictionaryMentionItemContainer = styled.div`
  display: inline-flex;
  align-items: center;
  border-radius: 6px;
  padding: 4px 6px;
  gap: 4px;
  background: var(--wash-gray-hover);
`;

const DeleteIcon = styled(Icon)`
  cursor: pointer;
`;

const TagText = styled(Text)`
  font-weight: 600;
  font-size: 12px;
`;

const DataDictionaryMentionItem = ({ item, onDelete }) => {
  const handleDeleteTag = () => {
    onDelete(item);
  };

  return (
    <DataDictionaryMentionItemContainer>
      <TagText $bold>{item.value}</TagText>
      <DeleteIcon
        name='close'
        size={24}
        displaySize={16}
        onClick={handleDeleteTag}
        color='var(--content-subtitle)'
      />
    </DataDictionaryMentionItemContainer>
  );
};

DataDictionaryMentionItem.propTypes = {
  item: PropTypes.string.isRequired,
  onDelete: PropTypes.func.isRequired
};

export { DataDictionaryMentionItem };
